import React from 'react'

const Permission = () => {
  return (
    <div>
      <h2 style={{ marginBottom: 0 }}>401</h2>
      <h4 style={{ marginTop: 0 }}>Pas accès !</h4>
    </div>
  )
}

export default Permission
